import type { MessageSchema } from "../hooks/useGuidedChat";

// Moss green from Figma for AI responses
const ASSISTANT_COLOR = "#638308";

interface MessageBubbleProps {
  message: MessageSchema;
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === "user";

  return (
    <div
      className={isUser ? "text-text-secondary" : ""}
      style={isUser ? undefined : { color: ASSISTANT_COLOR }}
    >
      <p className="whitespace-pre-wrap leading-relaxed text-base">
        {message.content}
      </p>
    </div>
  );
}
